import PageHelmet from '@bd/bdcore-pagehelmet';

// Placing this file here to update PageHelmet and use core version without rewriting all imports

export default PageHelmet;



// WEBPACK FOOTER //
// ./src/components/PageHelmet.js